import { Trans } from '@lingui/macro'
import { Card, CardContent, CardHeader, Stack } from '@mui/material'

import { INS_AUDIT_LOGS_PAGE_SIZE, useInsAuditLogs } from '../../model/useInsAuditLogs'
import { InsAuditLogsFilters } from './InsAuditLogsFilters'
import { InsAuditLogsTable } from './InsAuditLogsTable'

export function InsAuditLogs() {
  const { page, pageCount, total, logs, isLoading, isError, operation, searchQuery, handleOperationChange, handleSearchChange, handleReset, setPage } =
    useInsAuditLogs()

  return (
    <Stack spacing={3}>
      <Card>
        <CardHeader title={<Trans>INSi traces</Trans>} />
        <CardContent>
          <Stack spacing={2}>
            <InsAuditLogsFilters
              operation={operation}
              onOperationChange={handleOperationChange}
              searchQuery={searchQuery}
              onSearchChange={handleSearchChange}
              onReset={handleReset}
            />

            <InsAuditLogsTable
              logs={logs}
              isLoading={isLoading}
              isError={isError}
              page={page}
              pageCount={pageCount}
              total={total}
              pageSize={INS_AUDIT_LOGS_PAGE_SIZE}
              onPageChange={setPage}
            />
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  )
}
